module.exports = __webpack_public_path__ + "files/00e50e514f9ff670cbff5d5905f0bb80.png";